import React from 'react';
import doneImage from '../images/done.svg'
import { useNavigate } from 'react-router-dom';
import Header from './Header';

const FileUploadSuccess = () => {

    const navigate = useNavigate()

    return (
        <div className='bg-brand'>
            <div className="container">

                <Header />

                <div id='upload-document-container' className="bg-white-container mx-auto d-block mt-5">
                    <h2 className='fs-5 text-center pt-5 fw-bold'>File  was uploaded successfully</h2>

                    <img width={150} className='mx-auto d-block mt-5' src={doneImage} alt="upload successful" />

                    <button onClick={() => navigate('/')} className='btn-action mx-auto d-block mt-5 w-75'>Return Home</button>
                </div>

            </div>
        </div>
    );
};

export default FileUploadSuccess;